import { Button } from '@chakra-ui/button'
import { Checkbox } from '@chakra-ui/checkbox'
import { Flex } from '@chakra-ui/layout'
import { Td, Tr } from '@chakra-ui/table'
import { BiMessageSquareEdit } from 'react-icons/bi'
import { ImPrinter } from 'react-icons/im'
import { MdVisibility } from 'react-icons/md'
import { formatDate } from '../../utils/formatDate'
import { IconCheck } from './styles'
import { Link } from '@chakra-ui/layout'
import { Select, Text, Tooltip } from '@chakra-ui/react'
import { baseURL } from '../../services/api'
import { BiTrash } from 'react-icons/bi'
import ButtonDelete from './DevolucaoTrocaCompra/ButtonDelete'
import { useToast } from '@chakra-ui/react'
import { RecebimentoXbz } from '../StatusPedidos/RecebimentoMateriais/components/RecebimentoXbz'
import { Validation } from '../StatusPedidos/RecebimentoMateriais/components/Validation'
import { format, parseISO } from 'date-fns'
import moment from 'moment'

export function UsageTr({
  item,
  isAcompanhaCompras,
  isProduction,
  setDataModal,
  setObsFornecedor,
  pegarObservacao,
  setDadosModal,
  setDrawerOpen,
  setDrawerDescription,
  setDadosDrawer,
  atualizaPendenciaEtiqueta,
  pendencias,
  submitForm,
  checkOrRemoveCheck,
  isRecebimentoMateriais,
  setOpen,
  isCompra,
}) {
  function isPending(pendencia) {
    return pendencia === 'S'
      ? 'Pendente'
      : pendencia === 'N'
        ? 'Concluído'
        : pendencia === 'A'
          ? 'Atrasado'
          : pendencia === 'T'
            ? 'Solicitado'
            : pendencia === 'B'
              ? 'Atrasado com OBS'
              : 'Não informado'
  }

  const toast = useToast()

  async function sendStatusRecebimento(nunota, codprod, sequencia) {
    const codUsuario = JSON.parse(localStorage.getItem('authentication')).codigo_usuario

    const response = await baseURL.post('/pedido/atualiza-recebimento-status-acompanhamento', {
      nunota,
      codprod,
      sequencia,
      cod_usu: codUsuario,
    })
  }

  function getFunctionsOpenModal() {
    setDataModal(item)
    setObsFornecedor(item.observacaoFornecedor)
    !isProduction && !isAcompanhaCompras && pegarObservacao(item.observacao)
    setDadosModal(item)
    !isProduction && !isAcompanhaCompras && setOpen(true)
  }

  async function deleteItem(nunota, sequencia, codprod) {
    const params = {
      cod_prod: codprod,
      numero_nota: nunota,
      sequencia: sequencia,
    }
    console.log(params)
    try {
      const response = await baseURL.post('/pedido/remover-pedido-tela-troca', params)

      toast({
        title: 'Item removido com sucesso!',
        status: 'success',
        duration: 9000,
        isClosable: true,
      })

      console.log(response)
      submitForm()
    } catch (error) {
      console.log(error)

      toast({
        title: 'Erro ao remover item!',
        status: 'error',
        duration: 9000,
        isClosable: true,
      })
    }
  }

  return (
    <Tr cursor={!isProduction && !isAcompanhaCompras ? 'pointer' : ''} key={item.pedido_venda}>
      {!!isAcompanhaCompras && (
        <>
          <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
            <Text as="a" href={item.link_layout} target="_blank" rel="noreferrer" color={'blue.500'} textDecoration="underline">
              {item.numinno}
            </Text>

            <Flex alignItems="center" justifyContent="space-around" gap={1}>
              <BiMessageSquareEdit size="1.3rem" color="#378BBF" cursor="pointer" onClick={(e) => setDrawerOpen(true)} />
              <MdVisibility
                size="1.3rem"
                color="#378BBF"
                cursor="pointer"
                onClick={(e) => {
                  setDrawerDescription(true)
                  setDadosDrawer(item)
                }}
              />
            </Flex>
          </Td>
        </>
      )}
      {!isAcompanhaCompras && !isRecebimentoMateriais && (
        <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
          {item.fornecedor === 'XBZ' && item?.numero_xbz}
        </Td>
      )}
      <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
        {!isAcompanhaCompras ? (
          item.data_pedido ? (
            format(new Date(item.data_pedido), 'dd/MM/yyyy HH:mm')
          ) : (
            'Não informado'
          )
        ) : (
          <Flex flexDir="column">
            <Text>{item.data_pedido_compra && moment(item.data_pedido_compra?.split(' ')[0]).format('DD/MM/YYYY')}</Text>
            <Text>{item?.data_pedido_compra && moment(item.data_pedido_compra).format('HH:mm')}</Text>
            {item.dias_prazo_compra} {item.dias_prazo_compra > 1 ? ' Dias úteis' : ' Dia útil'}
          </Flex>
        )}
      </Td>
      {!isAcompanhaCompras && (
        <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
          {!isAcompanhaCompras && item.data_devolucao ? formatDate(item.data_devolucao) : 'Não informado'}
        </Td>
      )}
      <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
        {!isAcompanhaCompras ? (
          item.pedido_venda
        ) : (
          <Flex flexDir="column">
            {item?.data_compra ? (
              <>
                <Text
                  as="a"
                  href={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-pedido-compra-v2/${item?.pedido_compra}`}
                  target="_blank"
                  rel="noreferrer"
                  color="blue.500"
                  textDecoration="underline"
                  _hover={{ color: 'blue.600' }}
                >
                  {item.pedido_compra}
                </Text>
                <Text>{moment(item.data_compra).format('DD/MM/YYYY')}</Text>
                <Text>{moment(item.data_compra).format('HH:mm')}</Text>
              </>
            ) : (
              <Text
                as="a"
                href={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-pedido-compra/${item?.pedido_compra}`}
                target="_blank"
                rel="noreferrer"
                color="blue.500"
                textDecoration="underline"
                _hover={{ color: 'blue.600' }}
              >
                {item.pedido_compra}
              </Text>
            )}
          </Flex>
        )}
      </Td>
      <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
        <Tooltip label={!isAcompanhaCompras ? item.fornecedor : item.nome_fornecedor ? item.nome_fornecedor : 'Não informado'} aria-label="A tooltip">
          {!isAcompanhaCompras
            ? item.fornecedor.length > 10
              ? item.fornecedor.substring(0, 10) + '...'
              : item.fornecedor
                ? item.fornecedor
                : 'Não informado'
            : item.nome_fornecedor.length > 10
              ? item.nome_fornecedor.substring(0, 10) + '...'
              : item.nome_fornecedor}
        </Tooltip>
      </Td>
      {!isAcompanhaCompras && (
        <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
          {item.cod_innovation}
        </Td>
      )}
      <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
        {!isAcompanhaCompras ? (
          item.descricao ? (
            <Tooltip label={item.descricao} aria-label="A tooltip">
              {item.descricao.substring(0, 6) + '...'}
            </Tooltip>
          ) : (
            'Não informado'
          )
        ) : (
          <Tooltip label={item.descricao_produto} aria-label="A tooltip">
            {item.descricao_produto.substring(0, 6) + '...'}
          </Tooltip>
        )}
      </Td>
      {!!isAcompanhaCompras && (
        <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
          {item.cod_prod}
        </Td>
      )}
      <Td textAlign="center" paddingBlock=".3rem" paddingInline=".2rem" margin="0">
        {!isAcompanhaCompras ? (item.cor_produto ? item.cor_produto : 'Não informado') : item.id_cor_produto}
      </Td>
      <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
        {item.cod_fornecedor
          ? item.cod_fornecedor.length > 10
            ? item.cod_fornecedor.substring(0, 10) + '...'
            : item.cod_fornecedor
          : 'Não informado'}
      </Td>
      <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
        {item.quantidade_troca ? item.quantidade_troca : 'Não informado'}
      </Td>
      <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
        {item.data_saida_mercadoria ? formatDate(item.data_saida_mercadoria, true) : 'Não informado'}
      </Td>
      {!!isAcompanhaCompras && !isRecebimentoMateriais && (
        <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
          {item.data_pedido_chegou ? formatDate(item.data_pedido_chegou) : 'Não informado'}
        </Td>
      )}
      {!!isAcompanhaCompras && !isRecebimentoMateriais && (
        <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
          <Text
            as={'a'}
            href={item.link_layout}
            target="_blank"
            rel="noopener noreferrer"
            color={item.link_layout ? 'blue.500' : 'red.500'}
            textDecoration={item.link_layout ? 'underline' : 'none'}
          >
            {item.link_layout ? 'Abrir' : 'Não informado'}
          </Text>
        </Td>
      )}
      {!isAcompanhaCompras && (
        <Td
          textAlign="center"
          id="status"
          color={pendencias(isProduction ? item.status : item.status)}
          onClick={getFunctionsOpenModal}
          paddingBlock=".3rem"
          paddingInline=".2rem"
          margin="0"
        >
          {isProduction ? item.status : item.status}
        </Td>
      )}

      {!!isProduction && (
        <>
          <Td textAlign="center" paddingBlock=".3rem" paddingInline=".2rem" margin="0">
            <Button colorScheme="blue" display="flex" justifyContent="center" alignItems="center">
              <Link
                href={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-etiqueta-devolucao/${item.numero_nota}/${item.sequencia}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Imprimir <br /> etiqueta
              </Link>
              <ImPrinter size={25} />
            </Button>
          </Td>
          <Td textAlign="center" onClick={getFunctionsOpenModal} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
            {item.pendente_etiqueta === 'S' ? (
              <Button
                colorScheme="blue"
                display="flex"
                justifyContent="center"
                alignItems="center"
                onClick={(e) => {
                  atualizaPendenciaEtiqueta({
                    numero_nota: item.numero_nota,
                    sequencia: item.sequencia,
                    cod_prod: item.cod_innovation,
                    numero_venda: item.pedido_venda,
                  })
                  setTimeout(() => {
                    submitForm({ pendente_etiqueta: 'S' })
                    clearTimeout()
                  }, 300)
                }}
              >
                OK
              </Button>
            ) : (
              <IconCheck />
            )}
          </Td>
        </>
      )}
      {!!isAcompanhaCompras && !isRecebimentoMateriais && (
        <Td textAlign="center" paddingBlock=".3rem" paddingInline=".2rem" margin="0">
          <Flex alignItems="center" justifyContent="center">
            <Select
              onChange={(e) => e.target.value === 'R' && sendStatusRecebimento(item.numero_nota, item.cod_prod, item.sequencia, e.target.value)}
              maxW="100px"
              h="30px"
              defaultValue={item.status_recebimento}
            >
              <option value="">Selecione</option>
              <option value="R">Motorista retira</option>
            </Select>
          </Flex>
        </Td>
      )}

      {!!isAcompanhaCompras && (
        <>
          <Td textAlign="center" id="status" color={pendencias(item.pendente)} paddingBlock=".3rem" paddingInline=".2rem" margin="0">
            {isPending(item.pendente)}
          </Td>
          {!!isRecebimentoMateriais && (
            <Td textAlign="center" paddingBlock=".3rem" paddingInline=".2rem" margin="0">
              {item.nome_fornecedor === 'XBZ' ? <RecebimentoXbz checkOrRemoveCheck={checkOrRemoveCheck} data={item} onReload={submitForm} /> : ''}
            </Td>
          )}

          {!!isRecebimentoMateriais && (
            <Td textAlign="center">
              <Validation item={item} refresh={submitForm} />
            </Td>
          )}

          {/* {!!isRecebimentoMateriais && (
            <Td textAlign="center" paddingBlock=".3rem" paddingInline=".2rem" margin="0">
              {item.pendente === 'N' ? (
                <Checkbox
                  colorScheme="blue"
                  borderColor="blue.500"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  m="auto"
                  fontSize=".7rem"
                  width="15px"
                  height="30px"
                  isChecked={true}
                  onChange={(e) => {
                    checkOrRemoveCheck(item.pedido_venda, item.numero_nota, item.cod_prod, item.sequencia, e.target.checked)
                  }}
                />
              ) : (
                <Checkbox
                  colorScheme="blue"
                  borderColor="blue.500"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  m="auto"
                  fontSize=".7rem"
                  width="15px"
                  height="30px"
                  onChange={(e) => {
                    checkOrRemoveCheck(item.pedido_venda, item.numero_nota, item.cod_prod, item.sequencia, e.target.checked)
                  }}
                />
              )}
            </Td>
          )} */}
        </>
      )}
      {!!isCompra && (
        <Td textAlign="center" paddingBlock=".3rem" paddingInline=".2rem" margin="0">
          <ButtonDelete onClick={() => deleteItem(item.numero_nota, item.sequencia, item.cod_prod)} />
        </Td>
      )}
    </Tr>
  )
}
